<script>
import config from "../../config";
import { deliveryZoneService } from "../../services";
import { error_message, success_message, get_user } from "../../Helper/helper";
import { required,requiredIf } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { routes } from "../../config/api_routes";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: {Layout, PageHeader,DropzonePopup},
  data() {
    return {
      config: config,
      disable: false,
      typeform: {
        name: "",
        name_lang: "",
        image:"",
        status: "1",
      },
      zone_image: "",
      zone_image_path: "",
      zone_image_delete_url: routes.zoneImageDeleteUrl,
      typesubmit: false,
    };
  },
  validations: {
    typeform: {
      name:{
          required,
      },
      name_lang: {
          required
      },
      image:{
          //required,
          required:requiredIf(function (nestedModel) {
            return !(!!this.zone_image || !!this.typeform.image)
          })
      },
    },
  },
  mounted() {
    this.getDeliveryInfo();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
          evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
          evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
          evt.preventDefault();
      }
    },
    getDeliveryInfo() {
      deliveryZoneService
        .getDeliveryInfo({
          id: this.$route.params.id,
        })
        .then((response) => {
          const { id, name, name_lang,status } = response.data.result;
          this.zone_image_path = response.data.result.zone_image_path;
          this.zone_image = response.data.result.image;
          this.typeform = { id, name, name_lang,status };
          this.typeForm.image = '';
        });
    },
    typeForm(e) {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        deliveryZoneService.editDeliveryZone(this.typeform).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    onZoneImagedeleted(value) {
        this.zone_image = "";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-map-alt"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ typeform.name }}</h4>
              <p><router-link :to="{ name: 'list'}">{{ trans.get('__JSON__.Delivery Zones') }}</router-link> > {{ typeform.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
      <b-form action="#" @submit.prevent="typeForm">
        <!-- Delivery Zone Info Start -->
        <div class="card">
          <div class="card-body">
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-6" v-if="$auth.setting">
                  <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.Zone Name Primary',{ lang: $auth.langauges[0].name })}}</label>
                      <input
                          id="name"
                          v-model="$v.typeform.name.$model"
                          type="text"
                          class="form-control"
                          :placeholder="trans.trans('__JSON__.Zone Name Primary',{ lang: $auth.langauges[0].name })"
                          name="name"
                          :class="{ 'is-invalid': $v.typeform.name.$error }"
                      />
                      <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                          <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter zone name') }}</span>
                      </div>
                  </div>
              </div>

              <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                  <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.Zone Name Secondary',{ lang: $auth.langauges[1].name })}}</label>
                      <input
                          id="name_lang"
                          v-model="$v.typeform.name_lang.$model"
                          type="text"
                          class="form-control"
                          :placeholder="trans.trans('__JSON__.Zone Name Secondary',{ lang: $auth.langauges[1].name })"
                          name="name_lang"
                          :class="{ 'is-invalid': $v.typeform.name_lang.$error }"
                      />
                      <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                          <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter zone name') }}</span>
                      </div>
                  </div>
              </div>

              <div class="col-sm-6">
                  <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.Image')}}</label>
                      <dropzone-popup
                          v-model="$v.typeform.image.$model"
                          type="file"
                          id="image"
                          name="image"
                          acceptedFiles=".jpeg,.jpg,.png"
                          :editable-images="zone_image"
                          :media-path="zone_image_path+'/original'"
                          :delete-path="zone_image_delete_url"
                          @image-deleted="this.onZoneImagedeleted"
                      />
                      <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                      <span v-if="!$v.typeform.image.required" >{{ trans.get('__JSON__.Please select image') }}.</span>
                      </div>
                  </div>
              </div>

              <div class="col-sm-6 vendor-status">
                <b-form-group
                  id="input-group-1"
                  :label="trans.get('__JSON__.Status')"
                  label-for="status"
                >
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="togBtn"
                      name="status"
                      v-model="typeform.status"
                      class="switch-on"
                      true-value="1"
                      false-value="0"
                    />
                    <div class="slider round">
                      <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                      <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                    </div>
                  </label>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <button
                  type="submit"
                  class="btn btn-primary mr-1 mt-3"
                  :disabled="disable"
                >
                  {{ trans.get("__JSON__.Update Delivery Zone") }}
                </button>
                <b-button
                  @click="$router.go(-1)"
                  type="button"
                  variant="secondary"
                  class="mt-3"
                  >{{ trans.get("__JSON__.Cancel") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- Delivery Zone Info End -->
      </b-form>
      </div>
    </div>
  </Layout>
</template>
